import { Component } from '@angular/core';

@Component({
  selector: 'app-ngb-rating-demo',
  templateUrl: './rating-demo.component.html',
})
export class NgbRatingDemoComponent {
  public currentRate;
}
